const createTypographyStyle = (fontSize: string, fontWeight: string) => ({
  fontSize,
  fontFamily: 'Emeric,Arial,sans-serif',
  fontWeight,
  lineHeight: "1.33",
  color: "#004571",
});

const appStyles = {
  typographyTitle: {
    ...createTypographyStyle("30px", "300"),
    "@media (max-width: 520px)": {fontSize: "24px", },
  },
  typographySubtitle: {
    ...createTypographyStyle("18px", "600"),
    "@media (max-width: 520px)": {fontSize: "16px", },
  },
  formContainer: {
    margin: "130px auto",
    padding: "50px 62px",
    maxWidth: "768px",
    "@media (max-width: 520px)": {
      margin: "100px auto",
      padding: "32px",
    },
  },

  styledButton: {
      display: "flex",
      marginTop: "30px",
      alignItems: "center",
      justifyContent: "center",
      color: "#fff",
      border: "2px solid #E57200",
      backgroundColor: "#E57200",
      boxShadow: "0px 0px 1.8px rgba(0, 69, 113, 0.12), 0px 2.2px 7.2px rgba(0, 69, 113, 0.12)",
      minWidth: "135px",
      borderRadius: "50px",
      textTransform: "capitalize",
      fontWeight: "600",
    "& .MuiTouchRipple-root": {
      fontSize: "18px",
      fontFamily: 'Emeric,Arial,sans-serif',
      fontWeight: "600",
      lineHeight: "1.33",
      textTransform: "capitalize",
    },
    "&.Mui-disabled": {
      color: "#F9F8F7",
      borderColor: "transparent",
      backgroundColor: "rgba(229, 114, 0, 0.5)",
    },
    "@media (max-width: 520px)": {
      padding: "10px",
    },
  },

  typographyBody: {
    fontSize: "16px",
    fontFamily: 'Emeric,Arial,sans-serif',
    fontWeight: "300",
    lineHeight: "1.5",
    color: "#000000",
    margin: "25px 0",
    "&.color": {
      color: "#403D3A",
    },
    "@media (max-width: 520px)": {
      fontSize: "14px",
    },
  },
  containerForm: {
    display:"flex",
    flexWrap: "wrap",
    padding: "0px !important",
    justifyContent: "space-between",
  },
  typographyMessage: {
    fontSize: "16px",
    lineHeight: "2",
    fontWeight: "500",
    fontFamily: 'Emeric,Arial,sans-serif',
    color: "rgb(232 112 0)",
    backgroundColor: "rgba(255, 216, 51, 0.2)",
    padding: "24px",
    borderRadius: "4px",
    "@media (max-width: 520px)": {
      lineHeight: "1.5",
      padding: "24px 16px",
    },
  },
};

export default appStyles;
